// extracted by mini-css-extract-plugin
export default {"wrapper":"eU8arlH4","icon":"X9C5VDdJ"};